import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[appStoryblokEditable]',
})
export class StoryblokEditableDirective implements OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('appStoryblokEditable') appStoryblok: string;

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    this.assignStoryblokAttr();
  }

  assignStoryblokAttr(): void {
    if (typeof this.appStoryblok === 'undefined' || this.appStoryblok === null) {
      return;
    }

    const options = JSON.parse(this.appStoryblok.replace('<!--#storyblok#', '').replace('-->', ''));

    this.el.nativeElement.setAttribute('data-blok-c', JSON.stringify(options));
    this.el.nativeElement.setAttribute('data-blok-uid', `${options.id}-${options.uid}`);
  }
}

// Storyblok Directive
// _____________________
//
// Will add storyblok attributes on elements handle by Storyblok
// Needed for let Storyblok know what elements should listen for handling events from editor
